export default __webpack_public_path__ + "static/media/team.0672a9a8.jpg";